import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/core/infrastructure/classes/base-component';
import { REPRICING_INVENTORY_STATUS_STATE_DISPLAY } from '../forecast-rxdata-table/history-logs-ui/log-context/log-context.constant';
import { ItemPriceState } from 'src/app/core/models/history-log';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-item-pricing-inventory-health-chip',
  templateUrl: './item-pricing-inventory-health-chip.component.html',
  styleUrls: ['./item-pricing-inventory-health-chip.component.scss'],
})
export class ItemPricingInventoryHealthChipComponent extends BaseComponent {
  @Input() state: ItemPriceState;
  @Input() active = false;
  @Input() count?: number;
  @Input() sublabel?: string;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Output() chipClick = new EventEmitter<void>();

  readonly REPRICING_INVENTORY_STATUS_STATE_DISPLAY = REPRICING_INVENTORY_STATUS_STATE_DISPLAY;

  constructor(public sanitizer: DomSanitizer) {
    super();
  }

  onClick(event: MouseEvent): void {
    if (this.chipClick.observers.length > 0) {
      event.stopPropagation();
      this.chipClick.emit();
    }
  }
}
